import { Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { CHAT_PENDING_PROMPT_KEY } from '../../lib/editViaChat';

/**
 * "Edit with AI" action (CLE-41).
 *
 * The database is read-only from the user's perspective — every change is made
 * by the AI assistant (KB markdown -> sync). This button replaces direct edit
 * forms: it stashes a pre-filled prompt and routes the user to the chat page,
 * which picks the prompt up on mount.
 */
export function EditWithAIButton({
  prompt,
  label = 'Editează cu AI',
  className,
  variant = 'primary',
}: {
  /** The natural-language instruction to pre-fill in the chat composer. */
  prompt: string;
  label?: string;
  className?: string;
  variant?: 'primary' | 'secondary';
}) {
  const navigate = useNavigate();

  const base =
    'inline-flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors';
  const styles =
    variant === 'primary'
      ? 'bg-brand-600 text-white hover:bg-brand-700'
      : 'border border-gray-300 text-gray-700 hover:bg-gray-50';

  function go() {
    try {
      sessionStorage.setItem(CHAT_PENDING_PROMPT_KEY, prompt);
    } catch {
      // Ignore storage failures; the chat composer simply opens empty.
    }
    navigate('/chat');
  }

  return (
    <button type="button" onClick={go} className={className ?? `${base} ${styles}`}>
      <Sparkles size={15} />
      {label}
    </button>
  );
}
